import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm$produto, _vm$produto2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    ref: "modalLote",
    attrs: {
      "id": "loteModal",
      "title": _vm.compra ? 'Lote da compra' : 'Selecionar lote',
      "hide-footer": "",
      "size": "lg"
    }
  }, [_vm.compra ? _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.opcoesModoLote,
      "buttons": "",
      "button-variant": "outline-primary"
    },
    model: {
      value: _vm.modoLote,
      callback: function callback($$v) {
        _vm.modoLote = $$v;
      },
      expression: "modoLote"
    }
  })], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('p', [_c('strong', [_vm._v("Produto:")]), _vm._v(" " + _vm._s(((_vm$produto = _vm.produto) === null || _vm$produto === void 0 ? void 0 : _vm$produto.descricao) || "Não informado") + " ")]), _vm.modoLote === 'existente' ? _c('b-row', [_c('b-col', [(_vm$produto2 = _vm.produto) !== null && _vm$produto2 !== void 0 && _vm$produto2.baixa_automatica_lote ? _c('b-alert', {
    attrs: {
      "variant": "info",
      "show": ""
    }
  }, [_c('strong', [_vm._v("Atenção:")]), _vm._v(" Este produto está configurado para baixa automática de lotes. O sistema selecionará automaticamente o lote com vencimento mais próximo. ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm.modoLote === 'existente' ? _c('b-form-group', {
    attrs: {
      "label": "Pesquisar Número do Lote"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Digite o número do lote...",
      "debounce": "300"
    },
    model: {
      value: _vm.filtroLote,
      callback: function callback($$v) {
        _vm.filtroLote = $$v;
      },
      expression: "filtroLote"
    }
  })], 1) : _vm._e(), _vm.modoLote === 'existente' ? _c('div', {
    style: {
      maxHeight: _vm.lotesFiltrados.length > 5 ? '300px' : 'auto',
      overflowY: _vm.lotesFiltrados.length > 5 ? 'scroll' : 'visible'
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "items": _vm.loading ? [] : _vm.lotesFiltrados,
      "fields": _vm.campos,
      "select-mode": "single",
      "selectable": "",
      "busy": _vm.loading
    },
    on: {
      "row-selected": _vm.selecionarLote
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-3"
        }, [_c('b-spinner', {
          attrs: {
            "variant": "primary",
            "label": "Carregando..."
          }
        }), _c('p', [_vm._v("Carregando lotes...")])], 1)];
      },
      proxy: true
    }, {
      key: "cell(data_fabricacao)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.item.data_fabricacao)) + " ")];
      }
    }, {
      key: "cell(data_validade)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(row.item.data_validade)) + " ")];
      }
    }, {
      key: "cell(quantidade)",
      fn: function fn(row) {
        return [_c('span', {
          class: {
            'text-danger': row.item.quantidade <= 0
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(row.item.quantidade, "quantidade")) + " "), row.item.quantidade <= 0 ? _c('span', [_vm._v(" (Sem estoque)")]) : _vm._e()])];
      }
    }], null, false, 1359265353)
  })], 1) : _c('div', [_c('b-alert', {
    attrs: {
      "variant": "info",
      "show": ""
    }
  }, [_vm._v(" Cadastre o lote que receberá a quantidade desta compra. ")]), _c('b-form-group', {
    attrs: {
      "label": "Número do lote",
      "label-for": "novo-numero-lote"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "novo-numero-lote",
      "maxlength": "50",
      "placeholder": "Informe o número do lote"
    },
    model: {
      value: _vm.novoLote.numero_lote,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLote, "numero_lote", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "novoLote.numero_lote"
    }
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data de fabricação",
      "label-for": "novo-lote-fabricacao"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "id": "novo-lote-fabricacao",
      "locale": "pt-br"
    },
    model: {
      value: _vm.novoLote.data_fabricacao,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLote, "data_fabricacao", $$v);
      },
      expression: "novoLote.data_fabricacao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data de validade",
      "label-for": "novo-lote-validade"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "id": "novo-lote-validade",
      "locale": "pt-br"
    },
    model: {
      value: _vm.novoLote.data_validade,
      callback: function callback($$v) {
        _vm.$set(_vm.novoLote, "data_validade", $$v);
      },
      expression: "novoLote.data_validade"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_vm.modoLote === 'novo' && _vm.novoLote.numero_lote ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_c('p', [_c('strong', [_vm._v("Novo lote:")]), _vm._v(" " + _vm._s(_vm.novoLote.numero_lote))]), _vm.novoLote.data_validade ? _c('p', [_c('strong', [_vm._v("Validade:")]), _vm._v(" " + _vm._s(_vm.formatDate(_vm.novoLote.data_validade)) + " ")]) : _vm._e()]) : _vm.loteSelecionado ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_c('p', [_c('strong', [_vm._v("Lote Selecionado:")]), _vm._v(" " + _vm._s(_vm.loteSelecionado.numero_lote) + " ")]), _c('p', [_c('strong', [_vm._v("Validade:")]), _vm._v(" " + _vm._s(_vm.formatDate(_vm.loteSelecionado.data_validade)) + " ")]), _c('p', [_c('strong', [_vm._v("Disponível:")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.loteSelecionado.quantidade, "quantidade")) + " unidades ")])]) : _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" Nenhum lote selecionado ")]), _c('b-form-group', {
    attrs: {
      "label": _vm.compra ? 'Quantidade a alimentar' : 'Quantidade'
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.bloquearQuantidade || _vm.modoLote === 'existente' && !_vm.loteSelecionado,
      "min": "1",
      "max": !_vm.compra && _vm.loteSelecionado && _vm.loteSelecionado.quantidade > 0 ? _vm.loteSelecionado.quantidade : null
    },
    model: {
      value: _vm.quantidadeSelecionada,
      callback: function callback($$v) {
        _vm.quantidadeSelecionada = $$v;
      },
      expression: "quantidadeSelecionada"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.fecharModal
    }
  }, [_vm._v("Cancelar")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.podeConfirmar
    },
    on: {
      "click": _vm.confirmarSelecao
    }
  }, [_vm._v(" Confirmar ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };